import { InputField } from "@/components/Form";
import { useDebounce } from "@/hooks";
import { useGeneratePostDescriptionMutation } from "@/services/modules/post";
import { useEffect, useState } from "react";
import { UseFormSetValue } from "react-hook-form";

const AIInput = ({ setValue }: { setValue: UseFormSetValue<any> }) => {
  const debounceFn = useDebounce();
  const [generatePostDescription] = useGeneratePostDescriptionMutation();
  const [prompt, setPrompt] = useState("");

  useEffect(() => {
    if (prompt)
      (async () => {
        debounceFn(async () => {
          var result = await generatePostDescription(prompt).unwrap();
          setValue("description", result.description);
        }, 1800);
      })();
  }, [prompt]);

  return (
    <InputField
      type="text"
      placeholder="Search Description from AI"
      value={prompt}
      registration={{
        onChange: async ({ target }) => setPrompt(target.value),
      }}
    />
  );
};

export default AIInput;
